import React, { Component } from "react";

import "./Notification.css";
import NotificationCard from './NotificationCard/NotificationCard';
import Icon from '../Icon/Icon';
import {notificationIcons} from '../../../shared/constants';
import {relativeTime} from '../../../shared/utility';
import PropTypes from "prop-types";


/**
 * @desc Notification
 * @param props
 * @author Jamshith,Lakshmikandh
 */
class Notification extends Component {

  constructor(props) {
    super(props);
    this.state = {
      removedNotificationIds:[],
      removeClass:""
    };
  }

  /* removing a single notification card */

  handleRemoveNotification = (notificationId) => {
    const removedNotificationIds = [notificationId];
    this.setState({ removedNotificationIds : removedNotificationIds, removeClass: "card-remove" });
    this.props.handleRemoveNotification(notificationId); 

    if(this.setTimeout) {
      clearTimeout(this.setTimeout);
    }
    this.setTimeout = setTimeout(() => {
      this.setState({ removedNotificationIds : [], removeClass: "" });
    },1000);
  }

  /*clearing all notifications */

  handleClearNotification = ()=> {
    // this._div.scrollTop = 0
    const topPos = document.getElementById('notification-top').offsetTop;
    document.getElementById("notification-wrapper").scrollTop = topPos - 56;
    const notifications = [...this.props.notifications];
    let removedNotificationIds = [];
    const deleteArray = notifications.map((notification)=> {
      removedNotificationIds = removedNotificationIds.concat(notification.id);
      return {
        notificationId: notification.id,
        datetime: notification.datetime,
        remove:1
      } 
    });    
    
    this.props.handleClearNotification(deleteArray);
    this.setState({ 
      removedNotificationIds:removedNotificationIds, 
      removeClass: "card-clear-all" 
    });
    
    if(this.setTimeout) {
      clearTimeout(this.setTimeout);
    }
    // const timeout = ((0.3 + (notifications.length * 0.1)) * 1000) + 1000;
    this.setTimeout = setTimeout(() => {
      this.setState({ removedNotificationIds : [], removeClass: "" });
    },1200);    
  }

  componentWillUnmount() {
    if(this.setTimeout) {
      clearTimeout(this.setTimeout);
    }
  }

  render() {
    const {className,showNotification,notifications,...other} = this.props;
    return (
      <React.Fragment>
        <div className={showNotification ? "notification " + className : "notification-hide"}>
        <Icon 
          icon="clear-notification" 
          className={notifications.length > 0?"clear-notification":"clear-notification clear-disable"} 
          onClick={notifications.length > 0?()=>this.handleClearNotification():()=> {return false;}}
        ></Icon>        
        {notifications.length > 0?
          <div className="notification-cards" id="notification-wrapper">
            <div id="notification-top"></div>
            {notifications.map((notification, index)=>{
              let notificationClass = "";
              let notificationStyle = {}; 
              if(this.state.removedNotificationIds && this.state.removedNotificationIds.length > 0 && this.state.removedNotificationIds.includes(notification.id)) {
                notificationClass = "hide-notification " + this.state.removeClass;
                // const notificationTime = (0.2 + (index * 0.1));
                // const notificationDelay = (notificationTime + 0.1);
                // const visibilityDelay = (1 + notificationTime);
                // const notificationStyle = (this.state.removeClass && this.state.removeClass === "card-clear-all") ? { 'opacity': 0,'transition': `visibility 0s ${visibilityDelay}s, opacity 0.3s ${notificationDelay}s,  left 0.2s ease-in ${notificationDelay}s` } : {};
                // if(this.state.removeClass && this.state.removeClass === "card-clear-all") { 
                //   notificationStyle = { 'transitionDuration': '0.2s',
                //                         'transitionTimingFunction': 'ease',
                //                         'transitionProperty': 'all',
                //                         'transform': 'translate3d(100%, 0px, 0px)', 
                //                         'transitionDelay': notificationDelay + 's',
                //                         'opacity': 0
                //                       };
                // }
              } 
              // else {
              //   if(index > 0 && this.state.removedNotificationIds.length === 1 && this.state.removedNotificationIds[0] === this.props.notifications[index-1].id) {                  
              //     const height = document.getElementById(this.props.notifications[index-1].id).clientHeight;
              //     notificationStyle = { 
              //       'transform': `translateY(-${height+10}px)`,  
              //       'transitionDuration': '1s',   
              //       'transitionTimingFunction': 'ease'
              //     };
              //   } else {
              //     notificationStyle = {'transform': 'translateY(0)'};
              //   }
              // }

              return(
                <NotificationCard 
                  className={notificationClass}
                  time={relativeTime(notification.datetime)}
                  icon={notificationIcons[notification.type]}
                  content={notification.message} 
                  handleRemoveNotification={()=>this.handleRemoveNotification(notification.id)}
                  status={notification.status}
                  {...notification}
                  notificationStyle={notificationStyle}
                  cardId={notification.id}
                />
              );
            })}
          </div>
        : <div className="no-notification">You're all caught up!</div>
        }
        </div>
      </React.Fragment>
    );
  }
  
};


Notification.defaultProps = {
  showNotification: false,
  notifications: [],
};

Notification.propTypes = {
  showNotification: PropTypes.bool,
  notifications: PropTypes.array,
  handleClearNotification: PropTypes.func,
  handleRemoveNotification: PropTypes.func
};

export default Notification;


// WEBPACK FOOTER //
// ./src/components/UI/Notification/Notification.js